import {Price} from '../price';

export type UpsellBillingCycle = 'month' | 'year';

export function findBestPrice(
  token: UpsellBillingCycle,
  prices: Price[],
  currency?: string,
): Price | undefined {
  // Sort prices: default first, then latest (highest ID) first
  const sortedPrices = [...prices].sort((a, b) => {
    const aDefault = a.default ?? false;
    const bDefault = b.default ?? false;
    if (aDefault !== bDefault) {
      return aDefault ? -1 : 1;
    }
    return b.id - a.id;
  });

  // Filter prices by currency if specified
  const filteredPrices = currency ? sortedPrices.filter(p => p.currency === currency) : sortedPrices;
  
  if (token === 'month') {
    const match = findMonthlyPrice(filteredPrices);
    if (match) return match;
  }

  if (token === 'year') {
    const match = findYearlyPrice(filteredPrices);
    if (match) return match;
  }

  return filteredPrices[0];
}

function findYearlyPrice(prices: Price[]) {
  return prices.find(price => {
    if (price.interval === 'month' && price.interval_count >= 12) {
      return price;
    }
    if (price.interval === 'year' && price.interval_count >= 1) {
      return price;
    }
  });
}

function findMonthlyPrice(prices: Price[]) {
  return prices.find(price => {
    if (price.interval === 'day' && price.interval_count >= 30) {
      return price;
    }
    if (price.interval === 'month' && price.interval_count >= 1) {
      return price;
    }
  });
}
